export default {
  vm: null,
  title: '',
  variant: '',
  body: ''
}
